import { render, staticRenderFns } from "./EmployeesEditTimetableLessonsRecord.vue?vue&type=template&id=520d604a"
import script from "./EmployeesEditTimetableLessonsRecord.vue?vue&type=script&lang=js"
export * from "./EmployeesEditTimetableLessonsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports